module.exports = __webpack_public_path__ + "static/img/imgicon.8b6af1c3.svg";